<template>
	<div class="home">
		<Encabezado></Encabezado>

		<div id="content" class="snap-content bg-home">
			<div class="container">
				<div class="header-clear"></div>
				<div id="itemList">
					<div class="itemList-controls">
						<div class="controls controls-left">
							<router-link class="btn GeneralLeave-back btnBack" to="/modificaciones-datos-personales">
								<font-awesome-icon icon="fa-solid fa-circle-chevron-left" />
								Atrás
							</router-link>
						</div>
						<div class="title">
							<h3>Modificaciones de Datos Personales</h3>
						</div>
					</div>
					<div class="itemList-header">
						<h1>Nueva Modificación de Datos Personales</h1>
					</div>
					<div class="item-Form">
						<div class="panel-body">
							<form
								class="form-horizontal"
								id="formNuevaModificacion"
								@submit.prevent="enviarDatosFormulario"
							>
								<div class="form-group">
									<div class="col-md-12 col-xs-12">
										<label for="GeneralLeave_TipoModificacionValue"
											>Tipo de Modificación</label
										>
										<select
											v-model="idTipoModificacion"
											class="form-control valid"
											data-val="true"
											data-val-number="The field Tipo de Modificación must be a number."
											data-val-required="El campo Tipo de Modificación es obligatorio."
											id="GeneralLeave_TipoModificacionValue"
											name="GeneralLeave.TipoModificacionValue"
										>
											<option value="0">Selecciona un Tipo</option>
											<option
												v-for="tipoModificacion in tiposModificacion"
												:value="tipoModificacion.id"
											>
												{{ tipoModificacion.nombre }}
											</option>
										</select>
										<span v-if="idTipoModificacion!='0'" id="descripcionTipoModificacion">
											<div>
												<div>
													<span>
														{{ tipoModificacionSeleccionado.descripcion }}
													</span>
												</div>
												<div>
													<small
														v-if="
															tipoModificacionSeleccionado.descripcionJustificante
														"
													>
														Justificación:
														{{
															tipoModificacionSeleccionado.descripcionJustificante
														}}
													</small>
												</div>
											</div>
										</span>
									</div>
								</div>
								<hr v-if="idTipoModificacion!='0'" />
								<div v-if="idTipoModificacion!='0'" class="divAttachment">
									<div class="form-group">
										<div class="col-md-12">
											<label>Archivos adjuntos (máx. 3 archivos de 10Mb cada uno)</label>

											<br />
											<br />

											<input
												id="adjunto_1"
												class="hidden"
												type="file"
												ref="adjunto_1"
												@change="cambio_adjunto('adjunto_1')"
												accept=".pdf, .jpg, .jpeg"
												:capture="esAndroid ? 'environment' : null"
											/>

											<div class="input-group">
												<input
													placeholder="Archivo adjunto 1"
													type="text"
													id="caja_adjunto_1"
													class="form-control"
													readonly
													:value="nombreAdjunto_1"
													@click="seleccionarAdjunto('adjunto_1')"
												/>
												<span class="input-group-btn">
													<button
														type="button"
														class="btn btn-warning"
														@click="seleccionarAdjunto('adjunto_1')"
													>
														<font-awesome-icon icon="fa-solid fa-circle-plus" />
														Adjuntar
													</button>
												</span>
												<span class="input-group-btn">
													<button
														type="button"
														class="btn btn-danger"
														@click="quitarAdjunto('adjunto_1')"
													>
														<font-awesome-icon
															icon="fa-solid fa-times-circle"
														/>
														Quitar
													</button>
												</span>
											</div>

											<br />
											<br />

											<input
												id="adjunto_2"
												class="hidden"
												type="file"
												ref="adjunto_2"
												@change="cambio_adjunto('adjunto_2')"
												accept=".pdf, .jpg, .jpeg"
												:capture="esAndroid ? 'environment' : null"
											/>

											<div class="input-group">
												<input
													placeholder="Archivo adjunto 2"
													type="text"
													id="caja_adjunto_2"
													class="form-control"
													readonly
													:value="nombreAdjunto_2"
													@click="seleccionarAdjunto('adjunto_2')"
												/>
												<span class="input-group-btn">
													<button
														type="button"
														class="btn btn-warning"
														@click="seleccionarAdjunto('adjunto_2')"
													>
														<font-awesome-icon icon="fa-solid fa-circle-plus" />
														Adjuntar
													</button>
												</span>
												<span class="input-group-btn">
													<button
														type="button"
														class="btn btn-danger"
														@click="quitarAdjunto('adjunto_2')"
													>
														<font-awesome-icon
															icon="fa-solid fa-times-circle"
														/>
														Quitar
													</button>
												</span>
											</div>

											<br />
											<br />

											<input
												id="adjunto_3"
												class="hidden"
												type="file"
												ref="adjunto_3"
												@change="cambio_adjunto('adjunto_3')"
												accept=".pdf, .jpg, .jpeg"
												:capture="esAndroid ? 'environment' : null"
											/>

											<div class="input-group">
												<input
													placeholder="Archivo adjunto 3"
													type="text"
													id="caja_adjunto_3"
													class="form-control"
													readonly
													:value="nombreAdjunto_3"
													@click="seleccionarAdjunto('adjunto_3')"
												/>
												<span class="input-group-btn">
													<button
														type="button"
														class="btn btn-warning"
														@click="seleccionarAdjunto('adjunto_3')"
													>
														<font-awesome-icon icon="fa-solid fa-circle-plus" />
														Adjuntar
													</button>
												</span>
												<span class="input-group-btn">
													<button
														type="button"
														class="btn btn-danger"
														@click="quitarAdjunto('adjunto_3')"
													>
														<font-awesome-icon
															icon="fa-solid fa-times-circle"
														/>
														Quitar
													</button>
												</span>
											</div>
										</div>
									</div>
								</div>

								<hr v-if="idTipoModificacion!='0'" />

								<div v-if="idTipoModificacion!='0'" class="form-group">
									<div class="col-md-12">
										<label for="observaciones">Observaciones</label>
										<textarea
											class="form-control"
											cols="20"
											id="observaciones"
											name="observaciones"
											v-model="observaciones"
											rows="5"
										></textarea>
									</div>
								</div>
								<div class="form-group">
									<div class="col-md-12"></div>
								</div>
								<div v-if="idTipoModificacion!='0'" class="form-group">
									<div class="col-md-12">
										<div v-if="!cumpleJustificante" class="text-danger">
											Aviso.- El tipo de modificación seleccionado requiere que
											adjunte un justificante (<strong>{{
												tipoModificacionSeleccionado.descripcionJustificante.trim()
											}}</strong
											>)
										</div>
									</div>
								</div>
								<div v-if="idTipoModificacion!='0'" class="form-group">
									<div class="col-md-12">
										<input
										:disabled="!datosValidos || enviandoDatosFormulario"
											type="submit"
											class="btn btn-lg btn-primary"
											id="btnSave"
											:value="textoBtnEnvio"
										/>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import Encabezado from "@/components/Encabezado.vue";
import Footer from "@/components/Footer.vue";
import router from "@/router";
import moment from "moment";

export default {
	name: "NuevaModificacionDatosPersonales",
	components: {
		Encabezado,
		Footer
	},
	data() {
		return {
			idTipoModificacion: "0",
			adjunto_1: null,
			adjunto_2: null,
			adjunto_3: null,
            observaciones: null,
			limiteMegasAdjuntos: 10,
			esAndroid: /Android/i.test(navigator.userAgent)
		};
	},
	mounted() {
		this.$store.commit('establecerEstadoEnviandoDatosFormulario', false);
        this.$store.commit('establecerGuardadoOK', false);

        document.body.classList.remove("bg-login");
        document.body.classList.remove("login-page");

		this.idTipoModificacion = "0";
	},
	watch: {
		guardadoOK: function(newValue){
			if (newValue){
				this.$toast.open({
					message: "Los datos se han guardado correctamente",
					type: "success",
					duration: 1000,
					dismissible: false,
					position: "top",
					onDismiss: this.redireccionListaModificacionesDatosPersonales
				});
			}
		}
	},
	computed: {
		guardadoOK: function(){
            return this.$store.state.guardadoOK;
        },
		tiposModificacion: function () {
			const tiposModificacion = this.$store.state.perfil.tiposModificacion || [];

			return Array.isArray(tiposModificacion) ? tiposModificacion : [tiposModificacion];
		},
		tipoModificacionSeleccionado: function () {
			const self = this;
			
			return self.tiposModificacion.find((tipoModificacion) => {
				return tipoModificacion.id == self.idTipoModificacion;
			});
		},
		requiereJustificante: function () {
            return (!!(this.tipoModificacionSeleccionado.justificante * 1));
		},
		adjuntaJustificante: function () {
			return (!!this.adjunto_1 || !!this.adjunto_2 || !!this.adjunto_3);
		},
		cumpleJustificante: function () {
			return !this.requiereJustificante || (this.requiereJustificante && this.adjuntaJustificante);
		},
		datosValidos: function () {
			return this.cumpleJustificante;
		},
		textoBtnEnvio: function() {
			if (this.enviandoDatosFormulario) return 'Enviando...';
			if (this.datosValidos) return 'Enviar';
			if (!this.datosValidos) return 'Revise Avisos';  
		},
		tamanioMaximoAdjuntos: function(){
			return this.limiteMegasAdjuntos * 1048576;
		},
		enviandoDatosFormulario: function(){
			return this.$store.state.enviandoDatosFormulario; 
		},
		nombreAdjunto_1: function () {
			return !!this.adjunto_1 ? this.adjunto_1.name : "";
		},
		nombreAdjunto_2: function () {
			return !!this.adjunto_2 ? this.adjunto_2.name : "";
		},
		nombreAdjunto_3: function () {
			return !!this.adjunto_3 ? this.adjunto_3.name : "";
		}
	},
	methods: {
		formatDate: function (date) {
			return this.moment(date).format("DD/MM/YYYY hh:mm");
		},
		enviarDatosFormulario: function () {
			this.$store.dispatch("enviarDatosNuevaModificacionDatosPersonales", {
				idTipoModificacion: this.idTipoModificacion,
				adjunto_1: this.adjunto_1,
                adjunto_2: this.adjunto_2,
                adjunto_3: this.adjunto_3,
                observaciones: this.observaciones
			});
		},
		seleccionarAdjunto: function(id) {
			this.$refs[id].click();
		},
		quitarAdjunto: function(id) {
			this.$refs[id].value = "";
			if (id == 'adjunto_1') return this.adjunto_1 = null;
			if (id == 'adjunto_2') return this.adjunto_2 = null;
			if (id == 'adjunto_3') return this.adjunto_3 = null;
		},
		cambio_adjunto: function(id){
			const adjunto = this.$refs[id].files[0];
			const nombres_adjuntos = [
				this.nombreAdjunto_1.toUpperCase(), 
				this.nombreAdjunto_2.toUpperCase(), 
				this.nombreAdjunto_3.toUpperCase()
			];
			const expr_reg = /^[A-Za-z0-9-_\s]+[.]{1}[A-Za-z]{3,4}$/; //control del nombre del adjunto (sin eñes ni acentos)

			this.$refs[id].value = "";

			if (!expr_reg.test(adjunto.name)){
				return this.mostrarMensajeErrorNombreArchivoConCaracteresEspeciales();
			}

			if (nombres_adjuntos.includes(adjunto.name.toUpperCase())){
				if (adjunto.name.toUpperCase() === 'IMAGE.JPG'){
					const archivo = adjunto;
					const nombreUnico = `imagen_${Date.now()}.jpg`;
					const archivoRenombrado = new File([archivo], nombreUnico, {
						type: archivo.type,
						lastModified: archivo.lastModified
					});
					if (id === "adjunto_1") return this.adjunto_1 = archivoRenombrado;
					if (id === "adjunto_2") return this.adjunto_2 = archivoRenombrado;
					if (id === "adjunto_3") return this.adjunto_3 = archivoRenombrado;
				}
				return this.mostrarMensajeErrorMismoNombreAdjunto();
			}

			if (adjunto.size < this.tamanioMaximoAdjuntos){
				if (id === "adjunto_1") return this.adjunto_1 = adjunto;
				if (id === "adjunto_2") return this.adjunto_2 = adjunto;
				if (id === "adjunto_3") return this.adjunto_3 = adjunto;
			}

			this.mostrarMensajeErrorTamanioAdjunto();	
		},
		mostrarMensajeErrorMismoNombreAdjunto: function(){
			this.$toast.open({
				message: "Ya existe un archivo con el mismo nombre",
				type: "error",
				duration: 3000,
				dismissible: false,
				position: "top"
			});	
		},
		mostrarMensajeErrorNombreArchivoConCaracteresEspeciales: function(){
			this.$toast.open({
				message: "No se pueden añadir archivos con caracteres especiales en el nombre (ni eñes ni acentos)",
				type: "error",
				duration: 3000,
				dismissible: false,
				position: "top"
			});	
		},
		mostrarMensajeErrorTamanioAdjunto: function(){
			this.$toast.open({
				message: "No es posible adjuntar archivos de más de 10Mb",
				type: "error",
				duration: 3000,
				dismissible: false,
				position: "top"
			});
		},
		redireccionListaModificacionesDatosPersonales: function(){
			router.replace('/modificaciones-datos-personales');
			this.$store.commit('establecerGuardadoOK', false);
		}
	},
};
</script>

<style>
@import "../assets/styles/home.css";
</style>
